import { useField } from 'formik';
import { Form as SForm, TextArea, Label } from 'semantic-ui-react';
import { useFormikSchemaContext } from './FormikWithSchema';

interface Props {
    name: string;
    label?: string;
    required?: boolean;
    [key: string]: any;
}

const SemanticFormikTextArea: React.FC<Props> = ({ name, label, required, ...props }) => {
    const [field, meta] = useField(name);
    const schema = useFormikSchemaContext();
    const isRequired = schema?.isFieldRequired(name);
    const label_ = label ?? schema?.schema?.fields?.[name]?.spec?.label;
    const showError = meta.touched && !!meta.error;
    return (
        <SForm.Field error={showError} required={required ?? isRequired}>
            {label_ && <label htmlFor={name}>{label_}</label>}
            <TextArea name={name} {...field} {...props} id={name} />
            {showError && <Label basic color="red" pointing>{meta.error}</Label>}
        </SForm.Field>
    );
};

export default SemanticFormikTextArea;